import { createStore } from "./createStore";
import type { WorkbenchContainer } from "../types";

export interface WorkbenchesState {
  items: WorkbenchContainer[];
  activeId: string;
  loading: boolean;
  error: string | null;
}

// Mirror of vanilla apps/web/workbenches.js ACTIVE_KEY — persists the
// last-active workbench so reloads land back where the user left off.
const ACTIVE_WORKBENCH_KEY = "agentguard-active-workbench";

function readPersistedActiveId(): string {
  try {
    return localStorage.getItem(ACTIVE_WORKBENCH_KEY) || "wb-default";
  } catch {
    return "wb-default";
  }
}

export const workbenchesStore = createStore<WorkbenchesState>({
  items: [],
  activeId: readPersistedActiveId(),
  loading: false,
  error: null,
});

// Subscribe to active-id changes and persist them. This lives at module
// scope (singleton store) so the subscription only ever installs once,
// regardless of how many components mount.
let lastPersistedActiveId = readPersistedActiveId();
workbenchesStore.subscribe(() => {
  const current = workbenchesStore.getSnapshot().activeId;
  if (current && current !== lastPersistedActiveId) {
    lastPersistedActiveId = current;
    try {
      localStorage.setItem(ACTIVE_WORKBENCH_KEY, current);
    } catch {
      // hardened webviews may block localStorage; in-session selection still works.
    }
  }
});
